module.exports = __webpack_public_path__ + "img/rascrut-3.902d4bf6.jpg";